import type { UiPoint } from './types'

/** Keeps track of which type of gesture is happening. This is helpful
 * in case a user somehow changes from mouse to touch mid-gesture
 */
export type GestureType = 'MOUSE' | 'WHEEL' | 'TOUCH' | 'GESTURE'

/**
 * DOWN: Represents either mousedown, touchstart, or gesturestart
 * MOVE: Represents either mousemove, touchmove, or gesturechange
 * DOWN: Represents either mouseup, touchend, touchcancel, or gestureend
 */
export type ActionType = 'DOWN' | 'MOVE' | 'UP'

export type DraggingState = {
  /** The starting point of a gesture: the coordinates of the mouse at the start of the drag. */
  start: UiPoint

  /** The current point of a gesture: the current coordinates of the mouse during a drag. */
  current: UiPoint | null

  /** The type of gesture currently happening. */
  gesture: GestureType | null
}

export type DraggingAction = {
  type: 'DOWN' | 'MOVE' | 'UP'
  gesture: GestureType
  point: UiPoint
}

export const draggingReducer = (state: DraggingState, action: DraggingAction): DraggingState => {
  const { type, gesture, point } = action
  const { gesture: currentGesture } = state
  switch (type) {
    case 'DOWN':
      if (currentGesture && currentGesture !== gesture) return state
      return {
        ...state,
        start: point,
        current: null,
        gesture,
      }

    case 'MOVE':
      if (currentGesture !== gesture) return state
      return { ...state, current: point }

    case 'UP':
      if (currentGesture !== gesture) return state
      return { ...state, gesture: null }

    default:
      return state
  }
}
